import { getStore } from "store";

export const API_STATES = {
    default: {
        data: undefined,
        error: undefined,
        loaded: undefined,
        isLoading: undefined,
    },
    getStates: (setState) => ({
        pending: () =>
            setState({
                data: undefined,
                error: undefined,
                loaded: undefined,
                isLoading: true,
            }),
        success: (data) => {
            setState({
                data,
                error: null,
                loaded: true,
                isLoading: false,
            });

            return data;
        },
        error: (error) => {
            setState({
                data: undefined,
                error: error.message,
                loaded: false,
                isLoading: false,
            });

            return error;
        },
    }),
};

// Recursive variant converting from JSON to x-www-form-urlencoded with escaping names and values
export const JSONToFormURLEncoded = (element, key = "", list = []) => {
    if (typeof element == "object") {
        for (const idx in element) {
            JSONToFormURLEncoded(element[idx], key ? key + "[" + idx + "]" : idx, list);
        }
    } else {
        list.push(key + "=" + encodeURIComponent(element));
    }
    return list.join("&");
};

type TOptions = {
    bypassEnvironmentCheck?: boolean;
};

export const createAuthHeader = (options: TOptions = { bypassEnvironmentCheck: false }): any => {
    const store = getStore();
    const { lsid } = store.getState();
    if (!options.bypassEnvironmentCheck && process.env.NODE_ENV === "development") {
        return {};
    }

    return {
        Authorization: `Bearer ${lsid.token}`,
    };
};
